import { ApolloError, gql, useMutation } from "@apollo/client";
import { DelUserInput, DelUserOutput } from "../generated/graphql";

// mfc-react-admin에는 아직 delUser 훅이 없어서 새로 추가한다.
// (mfc-react-user 쪽 회원탈퇴 흐름과 동일한 백엔드 delUser 뮤테이션을 그대로 재사용 —
// 계정관리 페이지에서 관리자가 다른 직원/관리자 계정을 삭제할 때 쓴다.)
export interface DelUserMutation {
  delUser: DelUserOutput;
}

export interface DelUserMutationVariables {
  input: DelUserInput;
}

const DEL_USER_MUTATION = gql`
  mutation delUser($input: DelUserInput!) {
    delUser(input: $input) {
      ok
      err
    }
  }
`;

export const useDelUser = (
  onCompleted?: (data: DelUserMutation) => void,
  onError?: (error: ApolloError) => void
) => {
  return useMutation<DelUserMutation, DelUserMutationVariables>(
    DEL_USER_MUTATION,
    {
      onCompleted,
      onError,
    }
  );
};
